/**
 * Determines if a timeframe is actively ongoing.
 * @param {number} timeframe 
 * @returns {boolean} - True if timeframe is active, false otherwise
 */
export const isTimeframeActive = (timeframe) => {
    if (timeframe===13 || timeframe>14) return true;
    return false;
};



export const isTimeframeAcceptingNewLeagues = (timeframe) => {
    if (timeframe > 15) return true;
    return false;
}; 


export const isTimeframeAcceptingNewPorts = (timeframe) => {
    if (timeframe > 15) return true;
    return false;
}; 